export default __webpack_public_path__ + "static/media/sampleCsv.bb0f72b1.png";